// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chart-maximum"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 21H3V3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M7 16.9981C7 13.0114 7.99609 7.00391 13 7C18.0039 6.9961 19 13.0154 19 17.0038M6.99805 3.99805H7.00195V4.00195H6.99805V3.99805ZM9.99805 3.99805H10.002V4.00195H9.99805V3.99805ZM12.998 3.99805H13.002V4.00195H12.998V3.99805ZM15.998 3.99805H16.002V4.00195H15.998V3.99805ZM18.998 3.99805H19.002V4.00195H18.998V3.99805Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChartMaximumIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chart-maximum',
    ref,
    icon: element,
  },
));

ChartMaximumIcon.displayName = 'ChartMaximumIcon';

export default ChartMaximumIcon;
